import Vue from 'vue'
import VueRouter from 'vue-router'
import Offer from '@/views/Offer.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/:offerId?/:apiKey?',
    name: 'offer',
    component: Offer
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
